<template>
  <BaseModal
    name="ownerModal"
    width="820"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="clearData"
    :scrollable="true"
    height="auto"
    classes="tw-app-modal"
    @before-open="onOpenModal"
  >
    <div class="tw-app-modal__container">
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('ownerModal')"
      ></button>
      <BaseLoader v-show="saveLoader" class="tw-rounded-[25px]" />

      <div>
        <div class="tw-app-modal__title">
          <span v-if="!this.isCreateMode">
            Собственник/ Страхователь ID {{ dataForModal.object_owners__id }}
          </span>
          <span v-else> Создание собственника </span>
        </div>

        <!-- activateTab == 'fiz' -->
        <div
          class="tw-grid tw-grid-cols-2 tw-gap-[10px]"
          v-if="activateTab == 'fiz'"
        >
          <div>
            <div class="tw-mb-[10px]" ref="object_owners_fiz__fio">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_10"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="Иванов Иван Иванович"
                input-name="object_owners_fiz__fio"
                @change="updateValue"
                :value="dataForModal.object_owners_fiz__fio"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__date_of_birth">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_11"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="01.01.1950"
                :value="dataForModal.object_owners_fiz__date_of_birth"
                input-name="object_owners_fiz__date_of_birth"
                inputRef="object_owners_fiz__date_of_birth"
                inputMask="00.00.0000"
                @change="(data) => updateValue(data, { type: 'date' })"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__passport">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_21"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="1212 124578"
                inputRef="object_owners_fiz__passport"
                inputMask="0000 000000"
                maxLength="11"
                :value="dataForModal.object_owners_fiz__passport"
                input-name="object_owners_fiz__passport"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div
              class="tw-mb-[10px]"
              ref="object_owners_fiz__passport_created_by"
            >
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_22"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                :value="dataForModal.object_owners_fiz__passport_created_by"
                placeholder="УВД по г. Москве"
                input-name="object_owners_fiz__passport_created_by"
                @change="(data) => updateValue(data)"
              ></BaseInputNew>
            </div>

            <div
              class="tw-mb-[10px]"
              ref="object_owners_fiz__passport_created_at"
            >
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_23"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="27.03.2000"
                inputRef="object_owners_fiz__passport_created_at"
                inputMask="00.00.0000"
                :value="dataForModal.object_owners_fiz__passport_created_at"
                input-name="object_owners_fiz__passport_created_at"
                @change="
                  (data) => updateValue(data, { type: 'date', maxLength: 10 })
                "
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__passport_code">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_15"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="770-110"
                inputRef="object_owners_fiz__passport_code"
                inputMask="000-000"
                :value="dataForModal.object_owners_fiz__passport_code"
                input-name="object_owners_fiz__passport_code"
                @change="(data) => updateValue(data, { maxLength: 7 })"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__address">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_25"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="Москва, Тверская 6, кв.1"
                :value="dataForModal.object_owners_fiz__address"
                input-name="object_owners_fiz__address"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="" ref="object_owners_fiz__phone">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_26"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="+7(123)123-12-12"
                inputRef="object_owners_fiz__phone"
                inputMask="+7(000)000-00-00"
                maxLength="16"
                :value="dataForModal.object_owners_fiz__phone"
                input-name="object_owners_fiz__phone"
                @change="(data) => updateValue(data, { maxLength: 16 })"
              ></BaseInputNew>
            </div>
          </div>

          <div class="tw-bg-[#F1F3F5] tw-px-[30px] tw-py-[25px]">
            <div class="tw-font-[700] tw-text-center tw-mb-[10px]">
              Поля необязательные<br />
              для заполнения
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__bik">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_27"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                :value="dataForModal.object_owners_fiz__bik"
                input-name="object_owners_fiz__bik"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__ks">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_28"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_fiz__ks"
                input-name="object_owners_fiz__ks"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__rs">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_29"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_fiz__rs"
                input-name="object_owners_fiz__rs"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__bank">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_30"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_fiz__bank"
                input-name="object_owners_fiz__bank"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_fiz__drive_license">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_31"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="0987654321"
                :value="dataForModal.object_owners_fiz__drive_license"
                input-name="object_owners_fiz__drive_license"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div
              class="tw-mb-[10px]"
              ref="object_owners_fiz__drive_license_created"
            >
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_32"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="27.03.2000"
                inputRef="object_owners_fiz__drive_license_created"
                inputMask="00.00.0000"
                :value="dataForModal.object_owners_fiz__drive_license_created"
                input-name="object_owners_fiz__drive_license_created"
                @change="(data) => updateValue(data, { type: 'date' })"
              ></BaseInputNew>
            </div>
          </div>
        </div>
        <!-- activateTab == 'fiz' -->

        <!-- activateTab == 'ip' -->
        <div
          class="tw-grid tw-grid-cols-2 tw-gap-[10px]"
          v-if="activateTab == 'ip'"
        >
          <div>
            <div class="tw-mb-[10px]" ref="object_owners_ip__name">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_41"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3 !tw-pl-[40px]"
                  placeholder="Иванов Иван Иванович"
                  input-name="object_owners_ip__name"
                  @change="updateValue"
                  :value="dataForModal.object_owners_ip__name"
                ></BaseInputNew>
                <div
                  class="tw-absolute tw-left-[11px] tw-top-[25%] tw-text-[#899AB4] tw-pointer-events-none"
                >
                  ИП
                </div>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__ogrnip">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_35"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="1212124578"
                :value="dataForModal.object_owners_ip__ogrnip"
                input-name="object_owners_ip__ogrnip"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__inn">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_36"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="1212124578"
                :value="dataForModal.object_owners_ip__inn"
                input-name="object_owners_ip__inn"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__registered_at">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_44"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="27.03.2000"
                :value="dataForModal.object_owners_ip__registered_at"
                input-name="object_owners_ip__registered_at"
                inputRef="object_owners_ip__registered_at"
                inputMask="00.00.0000"
                @change="(data) => updateValue(data, { type: 'date' })"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__okved">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_38"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="73.11.1"
                inputRef="object_owners_ip__okved"
                inputMask="00.00.0"
                :value="dataForModal.object_owners_ip__okved"
                input-name="object_owners_ip__okved"
                @change="(data) => updateValue(data, { maxLength: 7 })"
              ></BaseInputNew>
            </div>

            <div>
              <div class="multiselect-type-3-label">
                Система налогооблажения*
              </div>
              <BaseSelect
                class="multiselect-type-3"
                open-direction="bottom"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="
                  (data) =>
                    updateValue(
                      {
                        name: 'object_owners_ip__tax_system',
                        value: data.object_owners_ip__tax_system,
                      },
                      { type: 'select' }
                    )
                "
                v-model="optionSelectValue.object_owners_ip__tax_system"
                :options="taxIPOptions"
                :customLabel="
                  ({ object_owners_ip__tax_system }) =>
                    `${dataLang[object_owners_ip__tax_system]}`
                "
              >
                <template #noOptions>Выберите систему</template>
              </BaseSelect>
            </div>
          </div>

          <div>
            <div class="tw-mb-[10px]" ref="object_owners_ip__bik">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_27"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_ip__bik"
                input-name="object_owners_ip__bik"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__ks">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_28"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_ip__ks"
                input-name="object_owners_ip__ks"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__rs">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_29"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_ip__rs"
                input-name="object_owners_ip__rs"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__bank">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_30"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                :value="dataForModal.object_owners_ip__bank"
                input-name="object_owners_ip__bank"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ip__address">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_51"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="Москва, Тверская 6, кв.1"
                :value="dataForModal.object_owners_ip__address"
                input-name="object_owners_ip__address"
                @change="updateValue"
              ></BaseInputNew>
            </div>

            <div ref="object_owners_ip__phone">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_26"] }}*
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder="+7(000)000-00-00"
                inputRef="object_owners_ip__phone"
                inputMask="+7(000)000-00-00"
                maxLength="16"
                :value="dataForModal.object_owners_ip__phone"
                input-name="object_owners_ip__phone"
                @change="(data) => updateValue(data, { type: 'phone' })"
              ></BaseInputNew>
            </div>
          </div>
        </div>
        <!-- activateTab == 'ip' -->

        <!-- activateTab == 'ur' -->
        <div
          class="tw-grid tw-grid-cols-2 tw-gap-[10px]"
          v-if="activateTab == 'ur'"
        >
          <div>
            <div class="tw-mb-[10px]" ref="object_owners_ur__name">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_62"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="ООО Прокат"
                  input-name="object_owners_ur__name"
                  @change="updateValue"
                  :value="dataForModal.object_owners_ur__name"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__ogrn">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_63"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="1212124578"
                  :value="dataForModal.object_owners_ur__ogrn"
                  input-name="object_owners_ur__ogrn"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__inn">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_36"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="1212124578"
                  :value="dataForModal.object_owners_ur__inn"
                  input-name="object_owners_ur__inn"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__kpp">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_65"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="121212133131"
                  :value="dataForModal.object_owners_ur__kpp"
                  input-name="object_owners_ur__kpp"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__head_fio">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_66"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="Иванов Иван Иванович"
                  :value="dataForModal.object_owners_ur__head_fio"
                  input-name="object_owners_ur__head_fio"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__head_jobtitle">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_67"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="Генеральный директор"
                  :value="dataForModal.object_owners_ur__head_jobtitle"
                  input-name="object_owners_ur__head_jobtitle"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div ref="object_owners_ur__head_by">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_68"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="Устава"
                  :value="dataForModal.object_owners_ur__head_by"
                  input-name="object_owners_ur__head_by"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>
          </div>

          <div>
            <div class="tw-mb-[10px]" ref="object_owners_ur__bik">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_27"] }}
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  :value="dataForModal.object_owners_ur__bik"
                  input-name="object_owners_ur__bik"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__ks">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_28"] }}
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  :value="dataForModal.object_owners_ur__ks"
                  class="wp-100 flex-column align-items-start"
                  input-name="object_owners_ur__ks"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__rs">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_29"] }}
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  :value="dataForModal.object_owners_ur__rs"
                  input-name="object_owners_ur__rs"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__bank">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_30"] }}
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  :value="dataForModal.object_owners_ur__bank"
                  input-name="object_owners_ur__bank"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__address">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_73"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="101000, Москва, Тверская, 10, офис 1"
                  :value="dataForModal.object_owners_ur__address"
                  input-name="object_owners_ur__address"
                  @change="updateValue"
                ></BaseInputNew>
              </div>
            </div>

            <div class="tw-mb-[10px]" ref="object_owners_ur__phone">
              <div class="tw-app-input-type-3-label">
                {{ dataLang["register_object_owners_text_26"] }}*
              </div>
              <div class="tw-relative">
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder="+7(123)123-12-12"
                  inputRef="object_owners_ur__phone"
                  inputMask="+7(000)000-00-00"
                  maxLength="16"
                  :value="dataForModal.object_owners_ur__phone"
                  input-name="object_owners_ur__phone"
                  @change="(data) => updateValue(data, { type: 'phone' })"
                ></BaseInputNew>
              </div>
            </div>

            <div ref="object_owners_ur__tax_system">
              <div class="multiselect-type-3-label">
                Система налогооблажения*
              </div>
              <BaseSelect
                class="multiselect-type-3"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                @input="
                  (data) =>
                    updateValue(
                      {
                        name: 'object_owners_ur__tax_system',
                        value: data.object_owners_ur__tax_system,
                      },
                      { type: 'select' }
                    )
                "
                v-model="optionSelectValue.object_owners_ur__tax_system"
                :options="taxUROptions"
                :customLabel="
                  ({ object_owners_ur__tax_system }) =>
                    `${dataLang[object_owners_ur__tax_system]}`
                "
              >
                <template #noOptions>Выберите систему</template>
              </BaseSelect>
            </div>
          </div>
        </div>
        <!-- activateTab == 'ur' -->
        <div class="tw-app-modal__footer !tw-justify-end">
          <button
            @click="$modal.hide('ownerModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { maxLength } from "vuelidate/lib/validators";

export default {
  components: {},

  props: {
    activateTab: {
      type: String,
    },
  },
  data() {
    return {
      taxIPOptions: [],
      taxUROptions: [],
      updatedValues: {},
      saveLoader: false,
      isCreateMode: false,
      dataForModal: {},
      optionSelectValue: {
        object_owners_ip__tax_system: {
          object_owners_ip__tax_system: "contract_prolongation_unselected",
        },
        object_owners_ur__tax_system: {
          object_owners_ur__tax_system: "contract_prolongation_unselected",
        },
      },
    };
  },
  methods: {
    clearData() {
      this.updatedValues = {};
      this.isCreateMode = false;
      this.optionSelectValue = {
        object_owners_ip__tax_system: {
          object_owners_ip__tax_system: "contract_prolongation_unselected",
        },
        object_owners_ur__tax_system: {
          object_owners_ur__tax_system: "contract_prolongation_unselected",
        },
      };
      this.$emit("close");
    },
    onOpenModal({ params }) {
      this.isCreateMode = params.isCreateMode;

      let fullResultData = params?.data;
      if (!this.isCreateMode && Object.keys(fullResultData).length) {
        this.optionSelectValue = {
          object_owners_ip__tax_system: {
            object_owners_ip__tax_system:
              fullResultData.object_owners_ip__tax_system ?? "",
          },
          object_owners_ur__tax_system: {
            object_owners_ur__tax_system:
              fullResultData.object_owners_ur__tax_system ?? "",
          },
        };

        Object.keys(fullResultData).forEach((el) => {
          let replaceKeys = [
            "object_owners_fiz__date_of_birth",
            "object_owners_fiz__drive_license_created",
            "object_owners_fiz__passport_created_at",
            "object_owners_ip__registered_at",
          ];
          if (replaceKeys.includes(el)) {
            console.log(fullResultData[el]);
            fullResultData[el] = fullResultData[el]
              ?.split("-")
              ?.reverse()
              ?.join(".");
          }
        });
      }
      this.dataForModal = fullResultData ?? {};
    },
    sendData() {
      if (Object.keys(this.updatedValues).length) {
        this.saveLoader = true;
        if (this.isCreateMode) {
          GeneralService.editOrCreate("/object-owners", {
            object_owners__type: `type_face_${this.activateTab}`,
            ...this.updatedValues,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
              this.$modal.hide("ownerModal");
            })
            .catch((err) => {
              if (err?.response?.data) {
                Object.keys(err.response.data.errors).forEach((elem, index) => {
                  this.$toast.error(err.response.data.errors[elem][0], {
                    duration: 5000,
                  });
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
                this.$toast.error(err.response.data.message, {
                  duration: 5000,
                });
              }
            })
            .finally(() => {
              this.saveLoader = false;
              // this.$modal.hide('ownerModal')
            });
        } else {
          GeneralService.edit(
            `/object-owners/${this.dataForModal.object_owners__id}`,
            {
              object_owners__type: `type_face_${this.activateTab}`,
              ...this.updatedValues,
            }
          )
            .then((data) => {
              this.$toast.success(data.data.message);
              this.$modal.hide("ownerModal");
            })
            .catch((err) => {
              if (err?.response?.data) {
                Object.keys(err.response.data.errors).forEach((elem, index) => {
                  this.$toast.error(err.response.data.errors[elem][0], {
                    duration: 5000,
                  });
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
                this.$toast.error(err.response.data.message, {
                  duration: 5000,
                });
              }
            })
            .finally(() => {
              this.saveLoader = false;
              // this.$modal.hide('ownerModal')
            });
        }
      } else {
        this.$modal.hide("ownerModal");
      }
    },
    updateValue(data, params = {}) {
      let resultData = data.value;
      if (Object.keys(params).length) {
        if (params?.maxLength && resultData.length > params?.maxLength) {
          resultData = resultData.slice(0, -1);
        }
        // if (params?.type == "date") {
        //   if (resultData.length > 10) {
        //     resultData = resultData.slice(0, -1);
        //   }
        //   if (resultData.length == 10) {
        //     resultData = resultData.split(".").reverse().join("-");
        //   }
        // }
      }

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      this.updatedValues[data.name] = resultData;
      if (params?.type !== "select") {
        this.$set(this.dataForModal, data.name, resultData);
        // this.dataForModal[data.name] = resultData;
      } else {
        this.$set(this.dataForModal, data.name, resultData);
      }
    },
  },
  mounted() {
    GeneralService.get(`/object-owners/select/tax`)
      .then((res) => {
        let data = res.data.data;
        this.taxIPOptions = data.map((i) => {
          let val = Object.values(i)[0];
          return { object_owners_ip__tax_system: val };
        });
        this.taxUROptions = data.map((i) => {
          let val = Object.values(i)[0];
          return { object_owners_ur__tax_system: val };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },

  created() {},
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
